import { render, staticRenderFns } from "./streamfieldBlock.vue?vue&type=template&id=ee7a4d1c&scoped=true&"
import script from "./streamfieldBlock.vue?vue&type=script&lang=js&"
export * from "./streamfieldBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7a4d1c",
  null
  
)

export default component.exports